import { DiscountType } from '@interfaces/discountCodes';
import { USER_ROLE } from '@utils/auth/roles';
import type { PreBookingPayload } from '@v2/views/flights/components/FlightsContent/FlightDrawer/FlightFares';

const FLIGHT_TAX = 13;
export const checkIsAffiliate = (userRole: number) => {
  return [
    USER_ROLE.affiliate,
    USER_ROLE.agency,
    USER_ROLE.agencyMember,
    USER_ROLE.individualAgent,
  ].includes(userRole);
};

/**
 * Roles scoped to the Client CRM APIs (agency book of business / individual agent).
 * Admins keep their own personal book too, so package shares they send are saved
 * into the CRM the same way an agent's are.
 */
export const checkIsCrmAgent = (userRole?: number | null) => {
  if (userRole == null) return false;
  return [
    USER_ROLE.admin,
    USER_ROLE.superAdmin,
    USER_ROLE.agency,
    USER_ROLE.agencyMember,
    USER_ROLE.individualAgent,
  ].includes(userRole);
};

export const getFlightPrice = (flightData: PreBookingPayload | null) => {
  if (!flightData) return 0;
  return Number(flightData?.simpleFare?.packagePrice) ?? 0;
};

export const getFlightFees = (flightPrice: number) => {
  const flightTaxPercentage = FLIGHT_TAX / 100;
  const flightFee = flightTaxPercentage * flightPrice;

  return flightFee;
};

export const getFlightCurrency = (flightData: PreBookingPayload | null) => {
  if (!flightData) return 'USD';
  return flightData?.simpleFare?.currency ?? 'USD';
};

export const calculateDiscount = ({
  packagePrice,
  flightPrice,
  discountAmount,
  discountType,
}: {
  packagePrice: number;
  flightPrice: number;
  discountAmount: number;
  discountType: DiscountType;
}) => {
  if (discountType === DiscountType.GiftCard) {
    // For gift cards, apply discount directly to total
    return Math.min(discountAmount, packagePrice);
  }

  // For promo codes, first subtract flight price then apply discount
  const priceWithoutFlight = packagePrice - flightPrice;
  return Math.min(discountAmount, priceWithoutFlight);
};
